"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.createPersonaReferenceResolver = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _CacheKeys = _interopRequireDefault(require("reference-resolvers/constants/CacheKeys"));

var _PersonasAPI = require("reference-resolvers/api/PersonasAPI");

var _createSimpleCachedReferenceResolver = _interopRequireDefault(require("reference-resolvers/lib/createSimpleCachedReferenceResolver"));

var createPersonaReferenceResolver = function createPersonaReferenceResolver(options) {
  return (0, _createSimpleCachedReferenceResolver.default)((0, _extends2.default)({
    cacheKey: _CacheKeys.default.PERSONAS,
    createFetchData: _PersonasAPI.createGetAllPersonas,
    fetchData: _PersonasAPI.getAllPersonas
  }, options));
};

exports.createPersonaReferenceResolver = createPersonaReferenceResolver;

var _default = createPersonaReferenceResolver();

exports.default = _default;